interface TickerProps {
  items: string[];
}

export function Ticker({ items }: TickerProps) {
  if (!items.length) return null;
  const stream = [...items, ...items]; // duplica pra loop visualmente continuo
  return (
    <div className="overflow-hidden border-y border-[--color-border] bg-[--color-bg-soft]">
      <div className="flex whitespace-nowrap py-2 animate-scroll">
        {stream.map((t, i) => (
          <span key={i} className="px-8 text-sm text-[--color-fg-dim]">
            <span className="mr-2 text-[--color-accent]">-</span>
            {t}
          </span>
        ))}
      </div>
    </div>
  );
}
